import { Box, Flex } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import { CloseIcon } from 'Asset/icon';
import { TextRegular, TextSemiBold } from '../typography';

import styles from './styles.module.css';
import { getColor } from '../toast/const';

const Alert = ({ isOpen = false, type = 'success', showIcon = true, title, description, onClose, ...props }) => {
  const { borderColor, icon, textColor } = getColor({ status: type });

  return (
    <Condition statement={isOpen}>
      <Box className={`${styles['alert__container']} ${styles[`alert__container--${type}`]}`} {...props}>
        <Flex alignItems={'flex-start'} gap={'8px'}>
          <Condition statement={showIcon} children={<Box className={styles['icon__container']}>{icon}</Box>} />
          <Box className={`${styles['alert__body']}`}>
            <TextSemiBold className={styles['alert__title']} color={textColor}>
              {title}
            </TextSemiBold>
            <TextRegular className={styles['alert__description']} color={textColor}>
              {description}
            </TextRegular>
          </Box>
        </Flex>
        <Condition statement={onClose}>
          <CloseIcon size="14" color={borderColor} onClick={onClose} className={styles['alert__close-button']} />
        </Condition>
      </Box>
    </Condition>
  );
};

export default Alert;
